import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import $ from "jquery";
import ChangePasswordModal from "../partial/ChangePasswordModal";
import { CMC_LANGUAGES } from "../constant/languages";

function Header() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [show, setShow] = useState(false);
  const [langSearch, setLangSearch] = useState("");

  const currentLang =
    CMC_LANGUAGES.find(
      (l) => l.code === i18n.language?.toLowerCase() || l.hreflang === i18n.language?.toLowerCase()
    ) ||
    CMC_LANGUAGES.find(
      (l) => l.code === i18n.language?.split("-")[0]?.toLowerCase()
    ) ||
    CMC_LANGUAGES[0];

  const filteredLanguages = CMC_LANGUAGES.filter((item) => {
    if (!langSearch.trim()) return true;
    const query = langSearch.toLowerCase();
    return (
      item.name.toLowerCase().includes(query) ||
      item.englishAbbreviation.toLowerCase().includes(query) ||
      item.code.toLowerCase().includes(query)
    );
  });

  const adminlogout = () => {
    localStorage.clear();
    logout();
    navigate("/");
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  useEffect(() => {
    $(document).ready(function () {
      $(".toggle-sidebar-btn").click(function () {
        $(".body").toggleClass("toggle-sidebar");
      });
    });
  }, []);

  const handleShow = (id) => {
    setShow(true);
  };

  return (
    <header id="header" className="header fixed-top d-flex align-items-center">
      <div className="d-flex align-items-center justify-content-between">
        <Link to="/dashboard" className="logo d-flex align-items-center">
          <img src="/assets/img/logo.png" alt="logo" />
          {/* <span className="d-none d-lg-block">0.3 Verse</span> */}
        </Link>
        <i className="bi bi-list toggle-sidebar-btn"></i>
      </div>
      <nav className="header-nav ms-auto">
        <ul className="d-flex align-items-center">
          {/* <li className="nav-item dropdown">
            <a className="nav-link nav-icon" href="#" data-bs-toggle="dropdown">
              <i className="bi bi-bell"></i>
              <span className="badge bg-primary badge-number">4</span>
            </a>
            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications">
              <li className="dropdown-header">
                You have 4 new notifications
                <a href="#">
                  <span className="badge rounded-pill bg-primary p-2 ms-2">
                    View all
                  </span>
                </a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li className="notification-item">
                <i className="bi bi-check-circle text-success"></i>
                <div>
                  <h4>Sit rerum fuga</h4>
                  <p>Quae dolorem earum veritatis oditseno</p>
                  <p>2 hrs. ago</p>
                </div>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
            </ul>
          </li> */}
          {/* <li className="nav-item dropdown">
            <a className="nav-link nav-icon" href="#" data-bs-toggle="dropdown">
              <i className="bi bi-chat-left-text"></i>
              <span className="badge bg-success badge-number">3</span>
            </a>
            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow messages">
              <li className="dropdown-header">
                You have 3 new messages
                <a href="#">
                  <span className="badge rounded-pill bg-primary p-2 ms-2">
                    View all
                  </span>
                </a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li className="message-item">
                <a href="#">
                  <img
                    src="/assets/img/messages-1.jpg"
                    alt=""
                    className="rounded-circle"
                  />
                  <div>
                    <h4>Maria Hudson</h4>
                    <p>
                      Velit asperiores et ducimus soluta repudiandae labore
                      officia est ut...
                    </p>
                    <p>4 hrs. ago</p>
                  </div>
                </a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li className="message-item">
                <a href="#">
                  <img
                    src="/assets/img/messages-2.jpg"
                    alt=""
                    className="rounded-circle"
                  />
                  <div>
                    <h4>Anna Nelson</h4>
                    <p>
                      Velit asperiores et ducimus soluta repudiandae labore
                      officia est ut...
                    </p>
                    <p>6 hrs. ago</p>
                  </div>
                </a>
              </li>
            </ul>
          </li> */}
          <li className="nav-item dropdown pe-3">
            <a
              className="nav-link nav-icon d-flex align-items-center gap-1"
              href="#"
              data-bs-toggle="dropdown"
              style={{ color: '#fff', textDecoration: 'none' }}
              title="Change Language"
            >
              <i className="bi bi-globe"></i>
              <span className="small text-uppercase fw-semibold ms-1" style={{ fontSize: '12px' }}>
                {currentLang.code}
              </span>
            </a>
            <ul
              className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile p-2"
              style={{ minWidth: '280px', maxWidth: '320px' }}
            >
              <li className="px-2 py-1 mb-1">
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="fw-bold small text-muted text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                    CoinMarketCap Languages ({CMC_LANGUAGES.length})
                  </span>
                  <span className="badge bg-light text-dark border">
                    {currentLang.name}
                  </span>
                </div>
                <div className="input-group input-group-sm">
                  <span className="input-group-text bg-light border-end-0">
                    <i className="bi bi-search text-muted"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control bg-light border-start-0"
                    placeholder="Search language..."
                    value={langSearch}
                    onChange={(e) => setLangSearch(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()}
                  />
                  {langSearch && (
                    <button
                      className="btn btn-outline-secondary border-start-0"
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        setLangSearch("");
                      }}
                    >
                      <i className="bi bi-x"></i>
                    </button>
                  )}
                </div>
              </li>
              <li>
                <hr className="dropdown-divider my-1" />
              </li>
              <div style={{ maxHeight: '340px', overflowY: 'auto' }}>
                {filteredLanguages.length > 0 ? (
                  filteredLanguages.map((lang) => {
                    const isSelected = currentLang.code === lang.code;
                    return (
                      <li key={lang.code}>
                        <button
                          className={`dropdown-item d-flex align-items-center justify-content-between py-2 px-3 rounded ${isSelected ? 'active bg-primary text-white' : ''}`}
                          onClick={() => changeLanguage(lang.code)}
                          style={{
                            cursor: 'pointer',
                            fontSize: '13px'
                          }}
                        >
                          <div className="d-flex align-items-center gap-2 text-truncate">
                            <span className="fw-semibold">{lang.name}</span>
                            {lang.englishAbbreviation && lang.englishAbbreviation !== lang.name && (
                              <span
                                className={`small ${isSelected ? 'text-white-50' : 'text-muted'}`}
                                style={{ fontSize: '11px' }}
                              >
                                ({lang.englishAbbreviation})
                              </span>
                            )}
                          </div>
                          {isSelected && (
                            <i className="bi bi-check-lg ms-2"></i>
                          )}
                        </button>
                      </li>
                    );
                  })
                ) : (
                  <li className="text-center text-muted py-3 small">
                    No language found
                  </li>
                )}
              </div>
            </ul>
          </li>
          <li className="nav-item dropdown pe-3">
            <a
              className="nav-link nav-profile d-flex align-items-center pe-0"
              href="#"
              data-bs-toggle="dropdown"
            >
              <img
                src="/assets/img/profile-img.jpg"
                alt="Profile"
                className="rounded-circle"
              />
              <span className="d-none d-md-block dropdown-toggle ps-2">
                Admin
              </span>
            </a>
            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
              <li className="dropdown-header">
                <h6>Welcome Admin</h6>

              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>

              <li>
                <Link
                  className="dropdown-item d-flex align-items-center"
                  to=""
                  onClick={() => handleShow()}
                >

                  <span>{t('change_password')}</span>
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item d-flex align-items-center"
                  to=""
                  onClick={(e) => adminlogout(e)}
                >
                  <i className="bi bi-box-arrow-right"></i>
                  <span>{t('logout')}</span>
                </Link>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>

              <li>
                <hr className="dropdown-divider" />
              </li>
            </ul>
          </li>
        </ul>
      </nav>
      <ChangePasswordModal show={show} setShow={setShow} logout={logout} />
    </header>
  );
}

export default Header;
